enum PlayerColor {
  Blue = 1,
  Orange = 2
}

export default PlayerColor